import { getAuthHeader, clearToken } from './auth';
import { getApiEndpoint } from '../config/api';

/**
 * Handle 401: redirect to login without throwing (avoids uncaught promise rejection).
 * Caller should not continue after 401 since we redirect.
 */
const handle401 = () => {
  clearToken();
  window.location.href = '/login';
};

/**
 * Authenticated fetch - adds auth header and handles 401 by redirecting to login.
 * Use this instead of raw fetch for API calls that require auth.
 */
export const fetchWithAuth = async (url, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...getAuthHeader(),
    ...options.headers
  };

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    handle401();
    return null; // Page will redirect; caller should check for null
  }

  return response;
};

export const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = getApiEndpoint(endpoint);
    const response = await fetchWithAuth(url, options);

    if (!response) return null; // 401 - redirected to login

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || data.message || `API request failed (${response.status})`);
    }

    return data;
  } catch (error) {
    if (error.message !== 'Authentication failed') {
      console.error('API request failed:', error);
    }
    throw error;
  }
}; 